import _ from 'lodash';

/**
 * @name searchIcons
 * @function
 * @description Поиск по списку иконок
 * @param list {array} - список иконок
 * @param value {string} - значение поиска
 */
export const searchIcons = (list, value) => {
  if (list) {
    if (value) {
      return list.filter((item) => {
        let isEmpty = false;
        for (let i = 0; i < item.search.length; i++) {
          if (item.search[i] && _.isString(item.search[i])) {
            if (item.search[i].indexOf(value.toLowerCase()) !== -1) {
              isEmpty = true;
              break;
            }
          }
        }
        return isEmpty;
      });
    }
    return list;
  }
  return false;
};

/**
 * @name getScrollToIndex
 * @function
 * @description Скроллим список к выбранной иконке
 * @param list {array} - список иконок
 * @param value {string} - выбранная иконка
 */
export const getScrollToIndex = (list, value) => {
  if (list && value) {
    const index = list.findIndex((item) => {
      const find = item.find((icon) => icon.value === value);
      return !!find;
    });
    if (index > 3) {
      return index + 3;
    }
  }
  return 0;
};
